NtechApp.MyResumeGridControls = function($view) {
    var me = this;

    this._$view = null;

    this._ajax = null;
    this._click = null;

    this._loader = null;
    this._overlay = null;

    // Uploaded resume select list
    this._$uploadedResumeListTrigger = null;
    this._$uploadResumeTrigger = null;

    this._$uploadedResumePopup = null;
    this._$uploadedResumePopupContent = null;

    this._uploadedResumeList = null;

    this._$uploader = null;

    // Fabalist resume select list
    this._$fabalistResumeListTrigger = null;

    this._$fabalistResumePopup = null;
    this._$fabalistResumePopupContent = null;

    this._fabalistResumeList = null;
    this._resumeSettingsForm = null;

    this._construct = function() {
        me._$view = $view;
        
        me._click = new NtechApp.TouchClickEvent();
        me._ajax = new NtechApp.Ajax();

        me._loader = new NtechApp.Loader();
        me._overlay = new NtechApp.Overlay();

        // Uploaded resume
        me._$uploadedResumeListTrigger = me._$view.find("[data-uploadedResumeSelectListTrigger]");
        me._$uploadResumeTrigger = me._$view.find("[data-uploadResumeTrigger]");
        me._$uploader = $("#jobsCenter").find("#uploadForm");

        me._createUploadedResumeList();

        me._uploadedResumeList = new NtechApp.SelectList(
            me._$uploadedResumePopup,
            me._$uploadedResumeListTrigger.find(".button"),
            null,
            -15
        );

        me._recreateUploadedResumeListContent();
        me._createUploader(me._$uploader);

        // Fabalist resume
        // Create select list only if resume was created(on new page)
        if($("body").find("[data-createFabalistResume]").length == 0) {
            me._$fabalistResumeListTrigger = me._$view.find("[data-fabalistResumeSelectListTrigger]");
            me._createFabalistResumeList();

            me._fabalistResumeList = new NtechApp.SelectList(
                me._$fabalistResumePopup,
                me._$fabalistResumeListTrigger.find(".button"),
                null,
                -15
            );

            me._recreateFabalistResumeListContent();
        }

        me._resumeSettingsForm = new NtechApp.ResumeSettingsForm();
        me._resumeSettingsForm.disableLoaders();

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen(me._$uploadedResumeListTrigger, function(e) {
            e.preventDefault();

            me._uploadedResumeList.on();
            return false;
        });

        if($("body").find("[data-createFabalistResume]").length == 0) {
            me._click.listen(me._$fabalistResumeListTrigger, function(e) {
                e.preventDefault();

                me._fabalistResumeList.on();
                return false;
            });
        }

        me._click.listen(me._$uploadResumeTrigger, function(e) {
            e.preventDefault();

            // Always find new file input to trigger(Blueimp replaces inputs)
            me._$uploader.find(":file").trigger("click");
            return false;
        });

        NtechApp.uploader.cancelBodyDrops();
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.MyResumeGridControls, {
    _enableLoader: function() {
        this._overlay.on();
        this._loader.on();
    },

    _disableLoader: function() {
        this._overlay.off();
        this._loader.off();
    },

    _createUploadedResumeList: function() {
        var me = this;

        me._$uploadedResumePopup = $("<div/>").appendTo($("body"));
        me._$uploadedResumePopup.addClass("defaultSelectListPopup");

        var $list = $("<div/>").addClass("list");
        var $scrollableList = $("<div/>").addClass("scrollableList");

        $list.append($scrollableList);
        me._$uploadedResumePopup.append($list);

        me._$uploadedResumePopupContent = $scrollableList;

        NtechApp.lockScroll(me._$uploadedResumePopupContent);
    },

    _recreateUploadedResumeListContent: function() {
        var me = this;
        var createItem = function(itemText) {
            var $item = $("<div/>").addClass("link");
            $item.text(itemText);

            me._$uploadedResumePopupContent.append($item);
            return $item;
        };

        me._$uploadedResumePopupContent.find(".link").remove();
        
        var $viewLink = createItem("View");
        var $reuploadLink = createItem("Reupload");
        var $removeLink = createItem("Remove");

        var viewLink = me._$uploadedResumeListTrigger.attr("data-uploadedResumeFileUrl");
        $viewLink.wrap($("<a/>").attr("href", viewLink).attr("target", "_blank"));

        this._bindUploadedResumeListContentEvents($reuploadLink, $removeLink);
    },

    _bindUploadedResumeListContentEvents: function($reuploadLink, $removeLink) {
        var me = this;
        me._click.listen($removeLink, function() {
            NtechApp.confirmForm.load(function() {
                me._ajax.post({
                    url: Routing.generate("personal_dashboard_rm_uploaded_resume"),
                    onSuccess: function(res) {
                        me._$uploadResumeTrigger.removeClass("hidden");
                        me._$uploadedResumeListTrigger.addClass("hidden");

                        NtechApp.confirmForm.unload();
                    },
                    onComplete: function() {
                        me._disableLoader();
                    }
                });
            });
        });

        me._click.listen($reuploadLink, function() {
            me._$uploader.find(":file").trigger("click");
        });
    },

    _createUploader: function($uploader) {
        var me = this;

        me._$uploader.find(":file").fileupload({
            dataType: 'json',
            formData: {
                uploadType: $uploader.attr("data-uploadType")
            },
            add: function(e, data) {
                $.each(data.files, function(index, file) {
                    if(!NtechApp.uploader.hasFileValidSize(file))
                        return;
                    
                    me._enableLoader();
                    data.submit();
                });
            },
            done: function (e, data) {
                $.each(data.result, function(i, fileData) {
                    if(fileData.error) {
                        NtechApp.info.on(fileData.errorMsg, 3000);
                        me._disableLoader();
                    }
                    else
                        me._finishUpload(data, fileData);
                });
            }
        });
    },

    _finishUpload: function(data, fileData) {
        var me = this;

        this._ajax.post({
            url: Routing.generate('personal_dashboard_save_uploaded_resume'),
            data: {
                filename: fileData.filename
            },
            onSuccess: function(res) {
                me._$uploadedResumeListTrigger.attr("data-uploadedResumeFileUrl", res.url);
                me._recreateUploadedResumeListContent();

                me._$uploadedResumeListTrigger.removeClass("hidden");
                me._$uploadResumeTrigger.addClass("hidden");

                me._resumeSettingsForm.loadForm(function() {
                    me._disableLoader();
                    NtechApp.info.on("Resume uploaded successfully!");
                });
            },
            onComplete: function() {
                me._loader.off();
            }
        });
    },

    _createFabalistResumeList: function() {
        var me = this;

        me._$fabalistResumePopup = $("<div/>").appendTo($("body"));
        me._$fabalistResumePopup.addClass("defaultSelectListPopup");

        var $list = $("<div/>").addClass("list");
        var $scrollableList = $("<div/>").addClass("scrollableList");

        $list.append($scrollableList);
        me._$fabalistResumePopup.append($list);

        me._$fabalistResumePopupContent = $scrollableList;

        NtechApp.lockScroll(me._$fabalistResumePopupContent);
    },

    _recreateFabalistResumeListContent: function() {
        var me = this;
        var createItem = function(itemText) {
            var $item = $("<div/>").addClass("link");
            $item.text(itemText);

            me._$fabalistResumePopupContent.append($item);
            return $item;
        };

        me._$fabalistResumePopupContent.find(".link").remove();
        
        var $viewLink = createItem("View");
        var $editLink = createItem("Edit");

        var viewLink = me._$fabalistResumeListTrigger.attr("data-fabalistViewResumeUrl");
        $viewLink.wrap($("<a/>").attr("href", viewLink));

        var editLink = me._$fabalistResumeListTrigger.attr("data-fabalistEditResumeUrl");
        $editLink.wrap($("<a/>").attr("href", editLink));
    }
});